import { useEffect, useState } from "react";
import { http } from "../../lib/api";

const when = (iso) => new Date(iso).toLocaleString("en-IN", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" });

export default function EmailLogsTab() {
  const [rows, setRows] = useState(null);
  useEffect(() => { http.get("/email-logs").then((r) => setRows(r.data)).catch(() => setRows([])); }, []);
  if (!rows) return <div className="chart-empty">Loading…</div>;
  const sent = rows.filter((r) => r.status === "sent").length;
  return (
    <>
      <div className="admin-top"><h1>Email & campaign log</h1>
        <div className="pill-row"><span className="pill" data-testid="email-sent-count"><b>{sent}</b> delivered</span><span className="pill bad" data-testid="email-failed-count"><b>{rows.length - sent}</b> failed</span></div>
      </div>
      <div className="leads-table-wrap">
        <table className="leads-table" data-testid="email-logs-table">
          <thead><tr><th>Time</th><th>Recipient</th><th>Subject</th><th>Type</th><th>Status</th><th>Details</th></tr></thead>
          <tbody>{rows.map((r) => (
            <tr key={r.log_id} data-testid={`email-log-row-${r.log_id}`}>
              <td>{when(r.created_at)}</td><td>{r.to}</td><td>{r.subject}</td><td>{r.kind}</td>
              <td><span className={`badge ${r.status === "sent" ? "ok" : "bad"}`}>{r.status}</span></td>
              <td className="log-detail">{r.error || r.provider_id || "—"}</td>
            </tr>
          ))}</tbody>
        </table>
        {rows.length === 0 && <div className="empty-state" data-testid="empty-email-logs-state">No emails sent yet.</div>}
      </div>
    </>
  );
}
